import styled from 'styled-components';

import SanityBlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';

export const StyledSanityBlockContent = styled(SanityBlockRenderer)`
  p {
    font-size: 14px;
    line-height: 20px;
    color: ${Styles.color.secondary};
  }
  a {
    color: ${Styles.color.primary};
  }
`;

export const SkeletonContentContainer = styled.div`
  width: 100%;
  padding: ${primitive.$spacing3} ${primitive.$spacing4};
`;
